// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import WebFont from 'webfontloader'
import VeeValidate, {Validator} from 'vee-validate'
import es from '@/assets/js/locale/vee.validate'
import Vuex from 'vuex'

Vue.use(VeeValidate, {
  events: ''
})
Vue.use(Vuex)

Validator.localize('es', es)
Vue.config.productionTip = false

const store = new Vuex.Store({
  state: {
    isLoggedIn: false,
    notification: null,
    loading: false,
    toggleSidebar: true
  },
  mutations: {
    login: state => { state.isLoggedIn = true },
    logout: state => { state.isLoggedIn = false },
    notificate (state, data) {
      state.notification = data
    },
    hideSidebar: state => { state.toggleSidebar = false },
    showSidebar: state => { state.toggleSidebar = true },
    wait: state => { state.loading = true },
    ready: state => { state.loading = false }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>',
  mounted: function () {
    WebFont.load({
      google: {
        families: ['Fira+Sans:100,300,400,500,600,700', 'Fira Mono:300,400']
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js